import { BackpackWalletAdapter } from '@solana/wallet-adapter-backpack';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import type { Adapter, WalletName } from '@solana/wallet-adapter-base';
import { BraveWalletAdapter } from '../adapters/braveWalletAdapter';
import { CwyNightlyWalletAdapter } from '../adapters/nightlyWalletAdapter';
import { CwyPhantomWalletAdapter } from '../adapters/phantomWalletAdapter';

let cwyAdaptersSingleton: Adapter[] | null = null;

export function createSolanaWalletAdapters(): Adapter[] {
  return [
    new CwyPhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    new BackpackWalletAdapter(),
    new BraveWalletAdapter(),
    new CwyNightlyWalletAdapter(),
  ];
}

/** Stable adapter instances — always use these for connect/sign, not Wallet Standard duplicates. */
export function getCwySolanaWalletAdapters(): Adapter[] {
  if (!cwyAdaptersSingleton) {
    cwyAdaptersSingleton = createSolanaWalletAdapters();
  }
  return cwyAdaptersSingleton;
}

export function getCwyWalletAdapter(adapterName: WalletName): Adapter | undefined {
  return getCwySolanaWalletAdapters().find((adapter) => adapter.name === adapterName);
}
